/**
 * Template ID constants for memory book pages
 */

export const FRONT_COVER_PAGE_IDS = [3, 4]
export const BACK_COVER_PAGE_ID = 18
export const SURNAME_PAGE_ID = 2
export const GLOBAL_SURNAME_PAGE_ID = 17
export const TREE_DESIGNS_PAGE_ID = 16
export const CREATE_YOUR_OWN_PAGE_ID = 19
